import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UtilMasks } from 'src/app/utils/util-masks';

@Component({
  selector: 'app-input-range-quantidade-preco',
  templateUrl: './input-range-quantidade-preco.component.html',
  styleUrls: ['./input-range-quantidade-preco.component.scss']
})
export class InputRangeQuantidadePrecoComponent implements OnInit {

  @Input() formList: FormGroup[] = [];
  @Input() disabled;

  masks = {
    moeda: { mask: UtilMasks.moeda, guide: false },
  }

  constructor() {

  }

  ngOnInit() {
    this.formList[0].controls.min.disable();
  }

  ngOnChanges() {
    this.formList[0].controls.min.disable();
  }

  addRange(min: number = null, valorConsulta = '') {

    if (this.formList.length > 0) {
      let lastGroup: FormGroup = this.formList[this.formList.length - 1];
      if (lastGroup.invalid) {
        lastGroup.controls.min.markAsTouched();
        lastGroup.controls.valorConsulta.markAsTouched();
        return;
      }
    }

    this.formList.push(new FormGroup({
      min: new FormControl({ value: min, disabled: this.formList.length == 0 }, [Validators.required]),
      valorConsulta: new FormControl(valorConsulta, [Validators.required]),
    }));
  }

  deleteRange() {
    if (this.formList.length > 1) {
      this.formList.pop();
    }
  }

  updateValidators() {

    for (let index = 0; index < this.formList.length; index++) {
      let min = 1;
      let max = null;
      if (index > 0) {
        min = this.formList[index - 1].controls.min.value + 1;
      }

      if (index < this.formList.length - 1 && this.formList[index + 1].controls.min.value) {
        max = this.formList[index + 1].controls.min.value - 1;
      }

      this.formList[index].controls.min.setValidators([
        Validators.required,
        Validators.min(min),
        Validators.max(max)
      ]);

    }
  }

}
